import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
Vue.config.productionTip = false

//引入config配置文件
import config from './static/js/config.js';
Vue.prototype.config = config;
const uni=require('./static/js/uni.webview.1.5.4.js')
Vue.prototype.$uni=uni
//引入全局注册组件
import components from './static/js/components.js';


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
